import {
  ListPersonsByPhoneLegacyRequest,
  SearchPersonsLegacyRequest,
} from '@weave/schema-gen-ts/dist/schemas/persons/v3/persons_service.pb';

export const convolutedInsanityCombinedPersonV3SearchKeys = {
  baseKey: ['persons-v3-convoluted-insanity-combined-search'],
  searchPersonsLegacyPost: (req: SearchPersonsLegacyRequest) => [
    ...convolutedInsanityCombinedPersonV3SearchKeys.baseKey,
    'person-search-legacy-post',
    { ...req },
  ],
  listPersonsByPhoneLegacy: (req: ListPersonsByPhoneLegacyRequest) => [
    ...convolutedInsanityCombinedPersonV3SearchKeys.baseKey,
    'list-persons-by-phone-legacy',
    { ...req },
  ],
  searchPersonsByPMIDLegacy: (req: SearchPersonsLegacyRequest) => [
    ...convolutedInsanityCombinedPersonV3SearchKeys.baseKey,
    'search-persons-by-pmid-legacy',
    { ...req },
  ],
};
